import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
// Define Variants that are not part of MUI's default subset https://v4.mui.com/api/typography/#typography-api
var globalFontFamily = "Inter";
// Note: fontFamily must be explicitly set on each CustomRaiseTypography variant because when these are spread
// into theme variants (e.g., button: {...CustomRaiseTypography.paragraph_small}),
// they completely override parent properties and don't inherit the top-level fontFamily.

export var CustomRaiseTypography = {
  display: {
    fontSize: "52px",
    lineHeight: "56px",
    letterSpacing: "-0.32px",
    textTransform: "none",
    fontFamily: globalFontFamily
  },
  // Paragraphs
  paragraph_large: {
    fontSize: "18px",
    lineHeight: "28px",
    textTransform: "none",
    fontFamily: globalFontFamily
  },
  paragraph_medium: {
    fontSize: "16px",
    lineHeight: "24px",
    textTransform: "none",
    fontFamily: globalFontFamily
  },
  paragraph_small: {
    fontSize: "14px",
    lineHeight: "20px",
    textTransform: "none",
    fontFamily: globalFontFamily
  },
  paragraph_xsmall: {
    fontSize: "12px",
    lineHeight: "20px",
    textTransform: "none",
    fontFamily: globalFontFamily
  },
  overline_large: {
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    fontFamily: globalFontFamily
  },
  overline_small: {
    fontSize: "12px",
    lineHeight: "20px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    fontFamily: globalFontFamily
  }
};

// Define variants that are part of MUI's default subset https://v4.mui.com/api/typography/#typography-api
export var RaiseTypography = {
  fontFamily: globalFontFamily,
  h1: {
    fontSize: "40px",
    lineHeight: "48px",
    letterSpacing: "-0.32px"
  },
  h2: {
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "-0.32px"
  },
  h3: {
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "-0.32px"
  },
  h4: {
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "-0.32px"
  },
  body1: _objectSpread({}, CustomRaiseTypography.paragraph_medium),
  body2: _objectSpread({}, CustomRaiseTypography.paragraph_small),
  // Overrides MUI Button
  button: _objectSpread({}, CustomRaiseTypography.paragraph_small)
};